export const errorStaticText: {
  [key: string]: string;
} = {
  default: "Something went wrong. Please try again later",

  /** USER GENERAL */
  "ChangePassword.NotAuthorizedException":
    "Current password does not match our records.",
  "ChangePassword.InvalidParameterException":
    "New Password is not a valid password. Please try again.",
  "ChangePassword.LimitExceededException":
    "Attempt limit exceeded. Please try again at a later time.",
  "ProfilePicture.InvalidFileType": "File must be a JPG or PNG",
  "MfaPhoneNumber.Invalid":
    "Provided phone number is invalid. Please try again.",
  "MfaTotp.InvalidAuthPayload":
    "Provided verification code is invalid. Please try again.",
  "MfaTotp.QrCode": "Cannot create a QR code. Please try again.",
  "MfaTotp.FactorNotVerified":
    "Provided verification code is invalid. Please try again.",
  "MfaSms.InvalidCode": "Invalid SMS verification code",
  "MfaSms.InvalidPhone": "Provided phone number is invalid. Please try again.",
  "MfaSms.NoPhone": "No phone number provided",
  "SignIn.SuspendedUser":
    "Your account is suspended. Please contact our support team.",
  "SignIn.NotAuthorizedException":
    "The email or password provided was incorrect. Please try again",
  "SignIn.WorkspaceRequired": "You need to log in using a workspace.",
  "SignIn.NoOrgs": "You are not part of any organization.",
  "SignIn.NoOrgsCurrentWorkspace":
    "You are not part of any organization in this workspace.",
  "ChangeEmail.EmailConflict":
    "Your account is already associated with that email address",
  "ConfirmEmail.CodeMismatchException":
    "Invalid verification code provided, please try again.",
  "ConfirmEmail.InvalidParameterException":
    "Invalid Verification Code. Please try again.",
  "ConfirmEmail.ExpiredCodeException":
    "The verification code has expired. Please try again.",
  "ConfirmForgotPassword.CodeMismatchException":
    "Invalid verification code provided, please try again.",
  "ConfirmChangeEmail.CodeMismatchException":
    "Invalid verification code provided, please try again.",
  "ConfirmChangeEmail.ExpiredCodeException":
    "Invalid verification code provided, please try again.",
  "ConfirmChangeEmail.LimitExceededException":
    "Attempt limit exceeded, please try again later.",
  "TerminateAccount.IncorrectPassword":
    "The password provided was incorrect. Please try again",
  "TerminateAccount.ActiveExternals":
    "This account still has external apps connected. Please close any connected accounts before trying again.",
  "CheckUserAppAccess.EmailMustMatchInvitation":
    "Your SSO account must use the same email address you were invited with.",
  "CheckUserAppAccess.InvitationExpired": "This invitation has expired.",
  "CheckUserAppAccess.AccessDenied":
    "This app is invitation only. You must recieve an invite link to proceed.",
  "Migration.SrcCredentialsAlreadyLinked":
    "Your account has been migrated. Please sign in to your Songtradr account.",
  "AuthSignInSecured.MissingToken":
    "The email or password provided was incorrect. Please try again",
  "getUserAttributes.MissingAttributes":
    "Failed to retrieve user attributes. Please try again later.",
  "GetInfo.MissingUserApps":
    "Failed to retrieve user apps. Please try again later.",
  "GetInfo.MissingSecurityInfo":
    "Failed to retrieve security information. Please try again later",
  "UpdateName.MissingGivenName":
    "First name is mandatory when providing a last name",

  /** ADMIN */
  "UpdateUserAttributes.EmailAlreadyExists":
    "The inputted email is already associated with another account",

  /** RSA */
  "Rsa.KeyFetchFailed": "Something went wrong (RKFF)",
  "Rsa.EncryptionKeyMissing": "Something went wrong (RENCM)",
  "Rsa.EncryptionFailed": "Something went wrong (RENCF)",
  "Rsa.InputTooLong": "Input is too long (RITL)",

  "ConfirmEmail.InvalidVerificationCode":
    "Invalid verification code provided, please try again.",

  "ForgotPassword.LimitExceededException":
    "Attempt limit exceeded. Please try again at a later time.",

  "ConfirmForgotPassword.InvalidVerificationCode":
    "Invalid verification code provided, please try again.",
  "ConfirmForgotPassword.UserNotFound":
    "We couldn't find an account for that email address.",

  /** WORKSPACE  */
  "VerifyWorkspace.OrgNotFound":
    "Check your workspace name is correct and try again. Alternatively, click 'Need help' below for more details.",
};
